import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE } from "@/core/constants";

// Импортируем все файлы переводов
import ru from "./ru.json";
// Добавьте другие языки по аналогии
// import en from "./en.json";

const resources = {
  ru: { translations: ru },
  // en: { translations: en },
};

export const options = {
  debug: false,
  fallbackLng: DEFAULT_LOCALE,
  resources,

  interpolation: {
    escapeValue: false,
  },

  ns: ["translations"],
  defaultNS: "translations",

  initImmediate: false,
};

// Initialize i18n for web
i18n.use(initReactI18next).init(options);

export default i18n;
